module.exports = __webpack_public_path__ + "img/base-skill-star.acb91d08.svg";